
  document.addEventListener('DOMContentLoaded', async function () {
    const fixedButtonContainer = document.querySelector('.c-hd-trucks__fixed-button-container');
    const fixedButton = document.querySelector('.c-hd-trucks__fixed-button-container button');

    // this script is render multi section. if you have to edit be careful.
    // side of dropdown image gallery swiper
    var ddBottomSwiper = new Swiper('.dd-swiperBottom', {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 6,
      freeMode: true,
      watchSlidesProgress: true,
      on: {
        init: function () {
          previousActiveIndex = this.activeIndex;
        },
        click: function () {
          if (this.clickedIndex < previousActiveIndex) {
            this.slideTo(this.clickedIndex - 1, 300, true);
          } else {
            this.slideTo(this.clickedIndex, 300, true);
          }
          previousActiveIndex = this.clickedIndex;
        },
      },
    });

    var ddTopSwiper = new Swiper('.dd-swiperTop', {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: ddBottomSwiper,
      },
    });

    const shareImgProduct = document.querySelectorAll('.share_img_product');
    if (!navigator.share) {
      shareImgProduct.forEach((each) => (each.style.display = 'none'));
    } else {
      shareImgProduct.forEach((each) => {
        each.addEventListener('click', (e) => {
          e.preventDefault();
          const shareData = {
            title: 'Pedal Commander',
            text: 'Hey, I just stumbled upon Pedal Commander. It is a performance part that will remove the acceleration lag from the throttle. Check it out!',
            url: `${window.location.href}`,
          };
          navigator
            .share(shareData)
            .then(() => {
              // console.log("page was shared");
            })
            .catch((error) => {
              console.log(error);
            });
        });
      });
    }

    function customSmoothScroll(x) {
      window.scrollTo({
        top: x,
        behavior: 'smooth',
      });
    }

    const xdBannerDropdownOpenId = document.querySelector('#xdBannerDropdownOpenId');
    function ddActions() {
      // if (window.innerWidth < 768) customSmoothScroll(755);
      if (window.innerWidth < 768) customSmoothScroll(1400);
    }

    xdBannerDropdownOpenId.addEventListener('click', ddActions);

    // -------------------------------

    const bottomDivider = document.querySelector('.pp-grid-parent');
    const buyNowButtonForMobile = document.querySelector('.buyNow-buy-now-mobile');
    const fixedBannerButton = document.querySelector('.fixed-banner-btn');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && window.innerWidth < 768) {
            // Banner görünmüyor ve ekran genişliği 768px'in altında ise

            // if( window.location.pathname.split('/').pop() != "suzuki-jimny"){
            // }
            buyNowButtonForMobile.style.display = 'block';

            fixedBannerButton.style.display = 'flex';
            // console.log("mobile buy now göster")
          } else {
            // Banner görünüyor veya ekran genişliği 768px'in üstünde ise
            buyNowButtonForMobile.style.display = 'none';
            // console.log("mobile buy now gizle")
          }
        });
      },
      { threshold: 0 }
    );

    // Observer'ı banner elementine bağla
    observer.observe(bottomDivider);

    // Pencere boyutu değiştiğinde kontrol et
    window.addEventListener('resize', () => {
      if (!observer) return;
      if (window.innerWidth < 768) {
        observer.observe(bottomDivider);
      } else {
        observer.unobserve(bottomDivider);
        buyNowButtonForMobile.style.display = 'none';
      }
    });
    // ---------------------------

    // tavk.to app
    if (window.innerWidth < 1000) styleTawkFunc();

    function styleTawkFunc() {
      const tawkWidgetInterval = setInterval(getTawkWidgetInterval, 1000);
      const clearTawkInterval = setInterval(clearTawkWidgetInterval, 10000);

      function getTawkWidgetInterval() {
        // console.log("tawk func run")
        let tawkWidgetVisibleIframe = document.querySelector('.richpanel-micro');

        if (tawkWidgetVisibleIframe) {
          // console.log("tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide')",tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide'))
          if (!tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide')) {              

            // fixedButtonContainer.style.width = "80%";
            // fixedButtonContainer.style.left = "20px";
            
            document.querySelector('.fixed-banner-btn button').style.fontSize = '22px';
            fixedButton.style.width = 'calc(100% - 100px)';

            console.log("tawk open --->");            
            
            clearInterval(tawkWidgetInterval);
          } else {
            
            fixedButton.style.width = '100%';
            console.log("tawk close --->");
          }
        }
      }

      function clearTawkWidgetInterval() {
        clearInterval(tawkWidgetInterval);
        clearInterval(clearTawkInterval);
        // console.log("tawk render edilmedi 10 sn sonra interval del")
      }
    }

    // anti_theft_black INFO
    // c-pp-anti-theft-title-available.liquid snippet
    const allAntiTheftTitleParent = document.querySelectorAll('.antiTheftTitleParent');

    allAntiTheftTitleParent.forEach((parent) => {
      const iconInfo = parent.querySelector('.antiTheftIconInfo');

      parent.addEventListener('mouseenter', () => {
        iconInfo.style.display = 'block';
      });

      parent.addEventListener('mouseleave', () => {
        iconInfo.style.display = 'none';
      });
    });

    // affirm duplicate render bug was fixed

    function moveAppToDesktop() {
      const mobileAffirm = document.querySelector('.onlyMobile .affirm_parent');
      const desktopAffirmContainer = document.querySelector('.desktop-affirm_parent');

      if (window.innerWidth >= 768 && mobileAffirm && desktopAffirmContainer) {
        desktopAffirmContainer.appendChild(mobileAffirm);
      }
    }

    moveAppToDesktop();

    window.addEventListener('resize', moveAppToDesktop);

    

    // DD START
    const ddContainer = document.querySelector('.pc-pro-dropdown-container');
    const ddContent = document.querySelector('.pc-pro-dropdown-content');
    const collectionHandle = ddContent.dataset.collectionHandle;
    const bestSellersTitle = ddContent.dataset.bestSellersTitle;
    const makesTitle = ddContent.dataset.makesTitle;
    const noVehicleFoundText = ddContent.dataset.noVehicleFound;
    const ddList = document.querySelector('.pc-pro-dd-list');
    const ddSelections = document.querySelector('.pc-pro-selection-container');
    const ddButton = document.querySelector('.dropdown-button');
    const makeModels = await getMakeModels();    
    const bestSellerMakes = ddContent.dataset.bestSellers?.split(',');    
    const filteredMakes = Object.keys(makeModels).filter((make) => !bestSellerMakes.includes(make));
    

    fixedButton.addEventListener('click', () => {      
      openDropdown();
    });
    let animationFrameId;
    const timeoutId = setTimeout(() => {
      cancelAnimationFrame(animationFrameId);
    }, 10000);    

    window.addEventListener('scroll', () => {
      const rect = ddButton.getBoundingClientRect();
      const isInView = rect.top >= 0 && rect.top <= window.innerHeight;
      if (isInView) {
        fixedButtonContainer.style.display = 'none';
      } else {
        fixedButtonContainer.style.display = 'block';
      }
    });

    getInitialDropdown({ addSearchBar: true });

    ddButton.addEventListener('click', handleDropdownButtonClick);

    // FUNCTIONS START

    function handleKeydown(e) {
      const highlightedElement = ddContent.querySelector('.pc-pro-dd-list-item.highlight');
      const focusableElements = ddContent.querySelectorAll(
        '.pc-pro-dd-list-item:not(.pc-pro-dd-search-bar-li):not(.pc-pro-dd-list-splitter):not(.no-hover)'
      );
      switch (e.key) {
        case 'Escape':
          closeDropdown();
          highlightedElement?.classList.remove('highlight');
          break;
        case 'ArrowDown': {
          e.preventDefault();
          ddContent.dataset.keyboardControls = 'true';
          const nextElement = highlightedElement?.nextElementSibling;
          if (!nextElement) {
            const elementToFocus = focusableElements[0];
            elementToFocus.classList.add('highlight');
            centerElementInContainer(elementToFocus, ddList);
          } else {
            highlightedElement.classList.remove('highlight');
            nextElement.classList.add('highlight');
            centerElementInContainer(nextElement, ddList);
          }
          break;
        }
        case 'ArrowUp': {
          e.preventDefault();
          ddContent.dataset.keyboardControls = 'true';
          const previousElement = highlightedElement?.previousElementSibling;
          if (!previousElement) {
            const elementToFocus = focusableElements[focusableElements.length - 1];
            elementToFocus.classList.add('highlight');
            centerElementInContainer(elementToFocus, ddList);
          } else {
            highlightedElement.classList.remove('highlight');
            previousElement.classList.add('highlight');
            centerElementInContainer(previousElement, ddList);
          }
          break;
        }
        case 'Enter':
          e.preventDefault();
          highlightedElement.click();
          break;
      }
    }

    function centerElementInContainer(element, container) {
      const elementRect = element.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const offset = elementRect.top - containerRect.top - containerRect.height / 2 + elementRect.height / 2;
      container.scrollTop += offset;
    }
    function getInitialDropdown({ addSearchBar }) {      
      if (addSearchBar) {
        appendSearchBar();
      }
      ddList.style.height = '';
      // const bestSellersSplitter = getSplitter({ text: bestSellersTitle });
      // ddList.append(bestSellersSplitter);
      // fillListMakes(bestSellerMakes);

      // const makesSplitter = getSplitter({ text: makesTitle });
      // ddList.append(makesSplitter);
      if (filteredMakes.length == 1) {
        fillListModels(filteredMakes[0]);
      } else {
        fillListMakes(filteredMakes);
      }
    }

    function handleDropdownButtonClick() {
      const isOpened = ddContent.dataset.dropdownOpened === 'true';
      if (isOpened) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    function openDropdown() {
      ddContent.dataset.dropdownOpened = true;
      ddContent.querySelector('.pc-pro-search-bar')?.focus();

      // scroll dd
      const ddContentyOffset = -80;
      const ddContenty = ddContent.querySelector('.pc-pro-search-bar').getBoundingClientRect().top + window.pageYOffset + ddContentyOffset;
      window.scrollTo({ top: ddContenty, behavior: 'smooth' });

      setDropdownHeight();
      window.addEventListener('keydown', handleKeydown);
      window.addEventListener('click', handleDocumentClick);
    }

    function closeDropdown() {
      ddContent.dataset.dropdownOpened = false;
      window.removeEventListener('keydown', handleKeydown);
      window.removeEventListener('click', handleDocumentClick);
      ddContent.dataset.keyboardControls = 'false';
    }

    function handleDocumentClick(e) {
      console.log(e);
      const closestDropdownContent = e.target.closest('.pc-pro-dropdown-content');
      if (!closestDropdownContent && !e.target.classList.contains('pc-pro-dd-list-item') && e.target !== fixedButton) {
        closeDropdown();
      }
    }

    function fillListMakes(items) {
      items.forEach((item) => {
        const liElement = getMakeListItem({ make: item });
        ddList.append(liElement);
      });
    }

    function fillListModels(make) {
      const models = makeModels[make];      

      clearDD();
      models.forEach((model) => {
        const liElement = getModelListItem({ model, link: `${make} ${model}` });
        ddList.append(liElement);
      });
      // console.log(models);
    }

    function clearDD() {
      const totalChildren = ddList.children.length;
      for (let i = totalChildren - 1; i > 0; i--) {
        ddList.removeChild(ddList.children[i]);
      }
    }

    function appendSearchBar() {
      const li = document.createElement('li');
      li.classList.add('pc-pro-dd-list-item', 'pc-pro-dd-search-bar-li');
      const input = document.createElement('input');
      input.type = 'text';
      input.classList.add('pc-pro-search-bar');
      input.addEventListener('input', handleSearchBarChange);
      input.placeholder = 'Search';
      li.append(input);
      ddList.append(li);
    }

    function handleSearchBarChange(e) {
      const searchValue = e.target.value.toLowerCase();
      ddList.style.height = '';

      clearDD();
      if (searchValue === '') {
        getInitialDropdown({ addSearchBar: false });
        setDropdownHeight();
        return;
      }
      const foundArray = [];
      Object.keys(makeModels).forEach((make) => {
        const models = makeModels[make];

        if (make.toLowerCase().includes(searchValue)) {
          foundArray.push({ type: 'make', name: make });
        }

        models.forEach((model) => {
          if (model.toLowerCase().includes(searchValue)) {
            foundArray.push({ type: 'model', name: `${make} ${model}` });
          }
        });
      });

      if (foundArray.length < 5) {
        const newHeight = 68 + foundArray.length * 52 + 'px';
        ddList.style.height = newHeight;
      }

      if (foundArray.length < 1) {
        const listItem = getListItem({ text: noVehicleFoundText });
        ddList.append(listItem);
        ddList.style.height = '120px';
        return;
      }

      foundArray.sort((a, b) => {
        if (a.type === 'make' && b.type === 'model') return -1;
        if (a.type === 'model' && b.type === 'make') return 1;
        return 0;
      });
      foundArray.forEach((item) => {
        if (item.type === 'make') {
          const makeLi = getMakeListItem({ make: item.name });
          ddList.append(makeLi);
        } else {
          const modelLi = getModelListItem({ model: item.name, link: item.name });
          ddList.append(modelLi);
        }
      });
      setDropdownHeight();
    }

    function getSplitter({ text }) {
      const li = document.createElement('li');
      li.classList.add('pc-pro-dd-list-item', 'pc-pro-dd-list-splitter');
      li.innerText = text;
      return li;
    }

    function getMakeListItem({ make }) {
      const li = document.createElement('li');
      li.classList.add('pc-pro-dd-list-item');
      li.innerText = make;
      li.addEventListener('click', () => {
        removeSelectionItems();
        if (makeModels[make].length < 5) {
          const newHeight = 68 + makeModels[make].length * 52 + 'px';
          ddList.style.height = newHeight;
        } else {
          ddList.style.height = '';
        }
        createSelectionItem({ text: make });
        fillListModels(make);
        document.querySelector('.pc-pro-search-bar').value = '';
      });
      addHighlightEventListeners(li);
      return li;
    }
    function getModelListItem({ model, link }) {
      const li = document.createElement('li');
      li.classList.add('pc-pro-dd-list-item');
      li.innerText = model;
      li.addEventListener('click', () => {
        redirectToProductPage(link);
      });
      addHighlightEventListeners(li);
      return li;
    }

    function addHighlightEventListeners(el) {
      el.addEventListener('mouseenter', () => {
        const isKeyboardMode = ddContent.dataset.keyboardControls === 'true';
        if (!isKeyboardMode) {
          el.classList.add('highlight');
        }
      });
      el.addEventListener('mouseleave', () => {
        const isKeyboardMode = ddContent.dataset.keyboardControls === 'true';
        if (!isKeyboardMode) {
          el.classList.remove('highlight');
        }
      });
    }

    function getListItem({ text }) {
      const li = document.createElement('li');
      li.classList.add('pc-pro-dd-list-item', 'no-hover');
      li.innerText = text;
      return li;
    }

    function redirectToProductPage(makeModel) {
      const changedMakeModel = makeModel.toLowerCase().replaceAll(' ', '-');
      window.location = `${window.Shopify.routes.root}products/${changedMakeModel}`;
    }

    function removeSelectionItems() {
      ddSelections.innerHTML = '';
    }
    function createSelectionItem({ text }) {
      const div = document.createElement('div');
      const cross = document.createElement('button');
      cross.classList.add('pc-pro-selection-delete');
      cross.addEventListener('click', () => {
        clearDD();
        getInitialDropdown({ addSearchBar: false });
        div.classList.remove('visible');
        setTimeout(() => {
          div.remove();
        }, 200);
      });
      const textEl = document.createElement('p');
      div.classList.add('pc-pro-selection-item');
      textEl.innerText = text;
      div.append(textEl, cross);
      ddSelections.append(div);
      setTimeout(() => {
        div.classList.add('visible');
      }, 20);
    }

    async function fetchAllProducts() {
      let hasNextPage = true;
      let endCursor = null;
      let allVariants = [];
      const endpoint = `/api/2024-07/graphql`;
      const headers = {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '960b68e3d27e55870e9ad333d5a199a1',
      };
      const fetchProducts = async (cursor = null) => {
        const query = `
      {
        collectionByHandle(handle: "${collectionHandle}") {
          products(first: 250${cursor ? `, after: "${cursor}"` : ''},) {
            pageInfo {
              hasNextPage
              endCursor
            }
            nodes {
              vendor
              variants(first: 1) {
                nodes {
                  title
                }
              }
              
            }
          }
        }
      }
      `;
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ query }),
          });

          const data = await response.json();
          // console.log(data);
          return data.data.collectionByHandle.products;
        } catch (error) {
          console.log(error);
          console.error('Error fetching GraphQL data:', error);
        }
      };

      while (hasNextPage) {
        const productsData = await fetchProducts(endCursor);
        allVariants = allVariants.concat(productsData.nodes.map((node) => node.variants.nodes[0].title));
        hasNextPage = productsData.pageInfo.hasNextPage;
        endCursor = productsData.pageInfo.endCursor;
      }


      return allVariants;
    }

    async function getMakeModels() {
      const allVariants = await fetchAllProducts();

      const makes = {};
      allVariants.forEach((variant) => {
        const [pcCode, make, model, year, engine] = variant.split('/').map((item) => item.trim());
        if (!pcCode.startsWith('PC')) return;
        if (!makes[make]) {
          makes[make] = [model];
        } else {
          makes[make].push(model);
        }
      });
      const orderedMakes = {};
      Object.keys(makes).map((key) => {
        const orderedModels = makes[key].sort();
        orderedMakes[key] = orderedModels;
      });
      
      return orderedMakes;
    }

    function setDropdownHeight() {
      const children = ddList.querySelectorAll('.pc-pro-dd-list-item');
      let totalHeight = 0;
      children.forEach((child) => {
        totalHeight += child.offsetHeight;
      });
      const newHeight = Math.min(totalHeight + 16, 324) + 'px';
      ddList.style.height = newHeight;
    }

    // DD END


    // LOOX CLICK START
    const col_trucs_loox_col = document.querySelectorAll(".appointedLoox");    
    const looxIntervalTime = 500;
    const looxInterval = setInterval(() => {
      const looxBtn = document.querySelector('.loox-floating-widget-btn');
      if (looxBtn) {                        
        looxBtn.style.backgroundColor = 'red';
        col_trucs_loox_col.forEach(item => {
          item.addEventListener('click', () => {            
            looxBtn.click();
          });
        })                
        clearInterval(looxInterval);
      }
    }, looxIntervalTime);
    // LOOX CLICK END


  });
